import { useCallback, useEffect, useState } from "react";
import { getCampaignNotificationHistory } from "../../../services/notification";

export const useCampaignNotificationHistory = (campaignId, filters) => {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [positionings, setPositionings] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(
    async (options = {}) => {
      if (!campaignId) {
        setRows([]);
        setTotal(0);
        setPositionings([]);
        setMaterials([]);
        setIsLoading(false);
        return null;
      }

      const { skipStateUpdate, ...requestOptions } = options;

      if (!skipStateUpdate) {
        setIsLoading(true);
        setError(null);
      }

      try {
        const response = await getCampaignNotificationHistory(campaignId, {
          periodDays: filters.periodDays,
          positioning: filters.positioning,
          material: filters.material,
          treatment: filters.treatment,
          removal: filters.removal,
          page: filters.page,
          pageSize: filters.pageSize,
          sortColumn: filters.sortColumn,
          sortDirection: filters.sortDirection,
          ...requestOptions,
        });

        const data = response.data ?? {};
        if (!skipStateUpdate) {
          setRows(data.rows ?? []);
          setTotal(data.total ?? 0);
          setPositionings(data.positionings ?? []);
          setMaterials(data.materials ?? []);
        }
        return data;
      } catch (err) {
        console.error("Error fetching campaign notification history:", err);
        if (!skipStateUpdate) {
          setError(err);
          setRows([]);
          setTotal(0);
          setPositionings([]);
          setMaterials([]);
        }
        return null;
      } finally {
        if (!skipStateUpdate) {
          setIsLoading(false);
        }
      }
    },
    [
      campaignId,
      filters.periodDays,
      filters.positioning,
      filters.material,
      filters.treatment,
      filters.removal,
      filters.page,
      filters.pageSize,
      filters.sortColumn,
      filters.sortDirection,
    ],
  );

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return {
    rows,
    total,
    positionings,
    materials,
    isLoading,
    error,
    fetchHistory,
  };
};
